import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-foreground-950 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20soft%20bokeh%20lights%20in%20warm%20golden%20and%20pink%20tones%2C%20dreamy%20defocused%20background%2C%20gentle%20gradient%2C%20ethereal%20and%20romantic%20atmosphere%2C%20subtle%20texture&width=1600&height=600&seq=yosuga-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-4">
          准备好踏入奥木染町的夏天了吗？
        </h2>
        <p className="text-foreground-400 text-base mb-8 max-w-xl mx-auto leading-relaxed">
          无论你是初次接触缘之空的新玩家，还是想要重温感动的老玩家，这里都有你想要的一切
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category?tab=剧情攻略"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-6 py-3 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line"></i>
            开始探索
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 bg-background-50/10 hover:bg-background-50/20 border border-background-50/20 text-background-50 font-medium px-6 py-3 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-team-line"></i>
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}